import React from 'react';
import './ProductGrid.css';

const ProductGrid = ({ products, onProductSelect, categoryColor }) => {
  // Function to convert hex to lighter rgba
  const getLighterColor = (hexColor) => {
    // Remove # if present
    const hex = hexColor.replace('#', '');
    
    // Convert hex to RGB
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    
    // Return a lighter version with opacity
    return `rgba(${r}, ${g}, ${b}, 0.7)`;
  };

  // Function to parse product name and extract size information
  const parseProductInfo = (productName) => {
    // Look for parentheses content as size information
    const sizeMatch = productName.match(/\(([^)]+)\)/);
    
    if (sizeMatch) {
      // Extract the main name (everything before the parentheses)
      const name = productName.substring(0, sizeMatch.index).trim();
      const size = sizeMatch[1];
      return { name, size };
    }
    
    // If no parentheses, check for common size patterns at the end
    const commonSizePatterns = [
      /\s+(por\s+\w+|kg|L|cc|gr?|unidad|pack\s+\d+u|entero|mediano|grande|chico|chica|individual|docena|media\s+docena)$/i,
      /\s+\d+\w+$/
    ];
    
    for (const pattern of commonSizePatterns) {
      const match = productName.match(pattern);
      if (match) {
        const name = productName.substring(0, match.index).trim();
        const size = match[0].trim();
        return { name, size };
      }
    }
    
    // If no size pattern found, return the full name and empty size
    return { name: productName, size: '' };
  };

  // Function to format price
  const formatPrice = (price) => {
    // Price is already in pesos, just format it
    return `$${Math.round(price)}`;
  };

  return (
    <div className="product-grid">
      <div className="products-container">
        {products.map((product) => {
          const { name, size } = parseProductInfo(product.name);
          return (
            <div
              key={product.id}
              className="product-card"
              style={{ 
                backgroundColor: categoryColor ? getLighterColor(categoryColor) : product.color,
                backdropFilter: 'blur(5px)',
                border: `2px solid ${categoryColor ? `rgba(${categoryColor.replace('#', '').match(/.{2}/g).map(hex => parseInt(hex, 16)).join(', ')}, 0.3)` : 'rgba(255, 255, 255, 0.2)'}`
              }}
              onClick={() => onProductSelect(product)}
            >
              <div className="product-name">{name}</div>
              {size && <div className="product-size">{size}</div>}
              <div className="product-grid-product-price">{formatPrice(product.price)}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProductGrid;